import { Body, Box, Flex, IconButton } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint/chakra';
import { iMoreHorizontal } from '@hover/icons';
import React from 'react';

import { TestLabels } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch/TestIds';
import { VariationColoredTexture } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/VariationColoredTexture';
import type { Variation } from 'src/modules/designStudio/helpers/productSelection/types';

export interface VariationThumbnailParams extends FlexProps {
  isSelected: boolean;
  variation: Variation;
  onApply: () => void;
  onViewMore: () => void;
}

export const VariationThumbnail = ({
  isSelected,
  variation,
  onApply,
  onViewMore,
  ...other
}: VariationThumbnailParams) => (
  <Flex
    data-testid={variation.uuid}
    direction="column"
    gap={0}
    label={TestLabels.VARIATION_THUMBNAIL}
    maxWidth="156px"
    {...other}
  >
    <Box maxWidth="156px" position="relative" width="100%">
      <VariationColoredTexture
        aria-label={TestLabels.VARIATION_THUMBNAIL_APPLY}
        borderRadius="15px"
        color={variation.color?.hex ?? undefined}
        height="156px"
        isSelected={isSelected}
        marginBottom={200}
        onClick={onApply}
        thumbnail={variation.thumbnailURL ?? ''}
        width="100%"
      />
      <IconButton
        aria-label={TestLabels.VARIATION_THUMBNAIL_DETAILS}
        bg="#03030364"
        height={300}
        icon={iMoreHorizontal}
        iconSize="medium"
        label=""
        onClick={onViewMore}
        position="absolute"
        right={200}
        size="small"
        top={200}
        width={300}
      />
    </Box>
    <Body fontSize={200} fontWeight={700} lineHeight="14.4px" my={0}>
      {variation.product.name}
    </Body>
    <Body
      color="neutral.900"
      fontSize={200}
      lineHeight="14.4px"
      marginTop={100}
    >
      {variation.name}
    </Body>
  </Flex>
);
